<template>
    <div class="position-box myAssets">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('my.wdzc')}}</div>
        </div>
        <div class="cotainer">
            <div class="assets-wrap">
                <img class="user-bg" src="@/assets/user/user-bg.png" alt="">
                <div class="assets-box">
                    <div class="assets-lt">
                        <div class="assets-tips">
                            <div class="text">{{$t('assets.total')}}</div>
                        </div>
                        <div class="assets">{{money}}</div>
                    </div>
                </div>
            </div>
            <ul class="checkbox-box" v-if="lang == 'ar'">
                <div class="text"><label for="checkbox">{{$t('assets.yczc')}}</label></div>
                <input id="checkbox" v-model="check" class="checkbox" type="checkbox">
            </ul>
             <ul class="checkbox-box" v-else>
                <input id="checkbox" v-model="check" class="checkbox" type="checkbox">
                <div class="text"><label for="checkbox">{{$t('assets.yczc')}}</label></div>
            </ul>
            <ul class="currency-box">
                <li class="currency-li" v-for="(item,index) in list" :key="index">
                    <div class="currency">{{item.currency}}</div>
                    <div class="currency-item">
                        <div class="item-lt">
                            <div class="t1">{{$t('assets.avaiable')}}</div>
                            <div class="t2">{{item.positions}}</div>
                        </div>
                        <div class="item-rt">
                            <div class="t1">{{$t('assets.conversion')}}(USDT)</div>
                            <div class="t2">{{ item.zh | toFixed4 }}</div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'myAssets',
    data () {
        return {
          theme: false,
          money: '',
          list:[],
          check: false,
          lang: 'en',
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getAsset()
    },
    methods: {
       back(){
           this.$router.push('/user')
       },
       getAsset(){
           this.$ajax.get('/web/getAsset2',{}).then((res) => {
                let resData = res.data.data;
                this.money = (Number(resData.totalMoney)).toFixed(4);
                if(this.check){
                    this.list = resData.list.filter((item) =>{
                        return item.positions > 0;
                    })
                }else{
                    this.list = resData.list
                }
            }).catch(function(err){
                console.log(err)
            })
       },
    },
    watch: {
		check:function(){
			this.getAsset();
		}
	},
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        left: .24rem;
        right: .24rem;
        top: 1.6rem;
        bottom: 0;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .assets-wrap{
        position: relative;
        height: 2.68rem;
        margin: 0 0 .24rem;
    }
    .assets-wrap .user-bg{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 2.68rem;
    }
    .assets-wrap .assets-box{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 2.68rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .6rem .56rem .7rem .6rem;
        box-sizing: border-box;
    }
    .assets-wrap .assets-box .assets-tips{
        display: flex;
        align-items: center;
    }
    .assets-wrap .assets-box .assets-tips .text{
        padding-right: .3rem;
        color: #fff;
        font-size: .4rem;
    }
    .assets-wrap .assets-box .assets-tips .icon{
        width: .6rem;
        /* height: .36rem; */
    }
    .assets-wrap .assets-box .assets{
        padding-top: .3rem;
        color: #fff;
        font-size: .6rem;
    }
    .assets-wrap .assets-box .arrow{
        width: .2rem;
    }
    .checkbox-box{
        display: flex;
        align-items: center;
    }
    .checkbox-box .text{
        padding-left: .2rem;
        color: #666;
        font-size: .42rem;
    }
    .currency-li{
        margin: .24rem 0;
        padding: .3rem .26rem .3rem .4rem;
        background: #fff;
        border-radius: 4px;
    }
    .currency-li .currency{
        color: #000;
        font-size: .42rem;
    }
    .currency-li .currency-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .currency-li .currency-item .t1{
        padding-top: .24rem;
        color: #7f7f7f;
        font-size: .36rem;
    }
    .currency-li .currency-item .t2{
        padding-top: .24rem;
        color: #333;
        font-size: .42rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/myAssets.vue